import { Printer } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface MachineCardProps {
  brand: string;
  model: string;
  variant: string;
  iconSize?: 'sm' | 'md';
}

function MachineCard({
  brand,
  model,
  variant,
  iconSize = 'md',
}: MachineCardProps) {
  const iconClass = iconSize === 'sm' ? 'w-4 h-4' : 'w-5 h-5';
  const titleClass = iconSize === 'sm' ? 'text-sm' : 'text-lg';

  return (
    <div className="flex items-center gap-3 w-full px-3 py-1">
      <div className="p-2 bg-accent rounded-lg">
        <Printer className={`${iconClass} text-primary`} />
      </div>
      <div className="flex flex-col gap-3 w-full">
        <h3 className={`font-semibold ${titleClass} text-left`}>{brand}</h3>
        <div className="flex gap-2 justify-between w-full">
          <Badge variant="outline" className="text-xs font-medium">
            {model}
          </Badge>
          <Badge variant="secondary" className="text-xs font-medium">
            {variant}
          </Badge>
        </div>
      </div>
    </div>
  );
}

export default MachineCard;
